/**
 * Navigation components.
 *
 * @module app/components/Navigation
 */
import HeaderNavigation from './HeaderNavigation';
import SwiperNavigation from './SwiperNavigation';

/**
 * Public functions.
 *
 * @type {Object}
 */
var api = {

    /**
     * Initialise things.
     *
     * @returns {void}
     *
     * @public
     */
    init: function () {

        HeaderNavigation.init();
        SwiperNavigation.initializeAllSwipers();
    },
};

export default api;
